module.exports =
  base: '/ecommerce'
  auth:
    init: '/ecommerce/:platform/init'
    finish: '/ecommerce/:platform/finish'
    escapeFrame: 'ecommerce/escapeFrame'
  health: '/ecommerce/health'

  dashboard:
    base: '/ecommerce/dashboard'
    product:
      base: '/ecommerce/dashboard/products'
      link: '/ecommerce/dashboard/products/link'
      linkShopifyAccess: '/ecommerce/dashboard/products/link/shopify/access'
    order:
      base: '/ecommerce/dashboard/orders'
      external:
        base:'/ecommerce/dashboard/orders/external/:platform'
        detail: '/ecommerce/dashboard/orders/external/:platform/:orderId'
        detailShopifyAccess: '/ecommerce/dashbaord/orders/external/detail/shopify/access'
    unlink:
      base: '/ecommerce/dashboard/unlink'
      platform: '/ecommerce/dashboard/:platform/unlink'

  data:
    item:
      base: '/ecommerce/data/items'
      bulkByVariantId: '/ecommerce/data/items/bulkByVariantId'
      ecomProducts:
        base: '/ecommerce/data/items/ecomProducts'
        variants: '/ecommerce/data/items/ecomProducts/:ecomProductId'
      count: '/ecommerce/data/items/count'
      defaults: '/ecommerce/data/items/defaults'
      bulk: '/ecommerce/data/items/bulk'
      detail: '/ecommerce/data/items/:itemId'
      unlink: '/ecommerce/data/items/unlink'
      new: '/ecommerce/data/items/new'
    lineItem:
      bulk: '/ecommerce/data/lineItem/bulk'
      bulkByLineItemId: '/ecommerce/data/lineItem/bulkByLineItemId'
      list: '/ecommerce/data/lineItem/list'
      flow: '/ecommerce/data/lineItem/flow'
      sync: '/ecommerce/data/lineItme/:platform/sync'
      detail: '/ecommerce/data/lineItem/:lineItemId'
      fulfill:
        search: '/ecommerce/lineItem/fulfill/search'
        batch: '/ecommerce/lineItem/fulfill/batch'
    external:
      products: '/ecommerce/data/:platform/shop/products'
      orders:
        base: '/ecommerce/data/:platform/orders'
        detail: '/ecommerce/data/:platform/orders/:orderId'
    order:
      fetchDate: '/ecommerce/data/:platform/order/fetchDate'
    collection: '/ecommerce/data/:platform/collection'
    version: '/ecommerce/data/:platform/version'

  webhooks:
    base: '/ecommerce/webhooks'
    scalable:
      base: '/ecommerce/webhooks/scalable'
    ecommerce:
      base: '/ecommerce/webhooks/:platform/:scope/:action'
      orders:
        base: '/ecommerce/webhooks/orders'
        create: '/ecommerce/webhooks/orders/create'
        updated: '/ecommerce/webhooks/orders/updated'
        cancelled: '/ecommerce/webhooks/orders/cancelled'
      products:
        base: '/ecommerce/webhooks/products'
        update: '/ecommerce/webhooks/products/update'
        delete: '/ecommerce/webhooks/products/delete'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/ecommerce.coffee